/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { PortalModal } from '../PortalModal/PortalModal';
import NotificationSnackBar from './NotificationSnackBar';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { hideNotificationAction } from '../../data/actions/notificationActions';

import { RootState } from '../../data/store.typings';

const Notification = () => {
    const dispatch = useDispatch();
    const notifications = useSelector(selectNotification, shallowEqual);

    return (
        <>
            {notifications && notifications.length !== 0 ? (
                <PortalModal>
                    <NotificationSnackBar
                        onClose={(index) => dispatch(hideNotificationAction(index))}
                        notifications={notifications}
                    />
                </PortalModal>
            ) : null}
        </>
    );
};

const selectNotification = (state: RootState) => {
    return state.notificationReducer.notifications;
};

export default Notification;
